import { Modal, Button } from 'react-bootstrap';

const PopupMessage = ({
  show,
  onClose,
  title,
  message,
  onConfirm
}) => {
  return (
    <Modal className='' show={show} onHide={onClose}>
      <Modal.Header closeButton>
        { title ?  <Modal.Title>{title}</Modal.Title> : null}
      </Modal.Header>
      <Modal.Body className='custom_body text-center'>
        <p className='mb-4'>{message}</p>

        <Button className='mx-3 px-3 my-0' variant="default" size={'sm'} onClick={onClose}>
          No
        </Button>
        <Button className='mx-3 px-3 my-0' variant="primary" size={'sm'} onClick={onConfirm}>
          Yes
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export { PopupMessage };